export default __webpack_public_path__ + "static/media/sorcery.1f289386.svg";